import React, { ReactNode } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  flex: 1;
  /* max-width: 1440px; */
  /* margin: 4px auto; */
  padding: 0 8px;
  border-radius: 2px;
  background: var(--elevation-light);
  /* height: 100%; */

  .isMobileStyle & {
    padding: 0 8px;
  }
`;

type Props = {
  children: ReactNode;
};

export default function WalletDashboardBody({ children }: Props) {
  // const isMobile = useSelector(state => state.screen.isMobile);
  return <Wrapper>{children}</Wrapper>;
}
